import { useResetRecoilState } from 'recoil';

import {
  editingProjectAssetFilesStateAtom,
  editingProjectBriefFilesStateAtom,
  editingProjectDeliveryDueDatesAtom,
  editingProjectStateAtom,
  editingProjectStateErrorsAtom,
} from '../atoms/editingProjectStateAtom';
import { isProjectFlatAtom } from '../atoms/isProjectFlatAtom';
import { projectAtom, projectLoadingAtom } from '../atoms/projectAtom';
import { workflowStepsAtom } from '../atoms/workflowStepsAtom';

export const useClearRecoilState = () => {
  const resetEditingProjectStateAtom = useResetRecoilState(editingProjectStateAtom);
  const resetEditingProjectStateErrorsAtom = useResetRecoilState(editingProjectStateErrorsAtom);
  const resetProjectAtom = useResetRecoilState(projectAtom);
  const resetProjectLoadingAtom = useResetRecoilState(projectLoadingAtom);
  const resetWorkflowStepsAtom = useResetRecoilState(workflowStepsAtom);
  const resetIsProjectFlatAtom = useResetRecoilState(isProjectFlatAtom);
  const resetEditingProjectBriefFilesStateAtom = useResetRecoilState(editingProjectBriefFilesStateAtom);
  const resetEditingProjectAssetFilesStateAtom = useResetRecoilState(editingProjectAssetFilesStateAtom);
  const resetEditingProjectDeliveryDueDatesAtom = useResetRecoilState(editingProjectDeliveryDueDatesAtom);

  return () => {
    resetEditingProjectStateAtom();
    resetEditingProjectStateErrorsAtom();
    resetProjectAtom();
    resetProjectLoadingAtom();
    resetWorkflowStepsAtom();
    resetIsProjectFlatAtom();
    resetEditingProjectBriefFilesStateAtom();
    resetEditingProjectAssetFilesStateAtom();
    resetEditingProjectDeliveryDueDatesAtom();
  };
};
